import { render, staticRenderFns } from "./bao-cao-ton-kho-vn.vue?vue&type=template&id=213f3f1b&"
import script from "./bao-cao-ton-kho-vn.vue?vue&type=script&lang=js&"
export * from "./bao-cao-ton-kho-vn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports